import Vue, { PropType } from "vue";
import { ArrowDirection, CellState, ICell } from "js/crossword/types";
import OS from "framework/utils/OS";

import style from "../css/BoardCell.module.css";
import getCellClasses from "./getCellClasses";

const arrowDirToURL: Record<ArrowDirection, string> = {
  [ArrowDirection.Down]: 'images/ArrowDown.svg',
  [ArrowDirection.LeftDown]: 'images/ArrowLeftDown.svg',
  [ArrowDirection.RightDown]: 'images/ArrowRightDown.svg',
  [ArrowDirection.Right]: 'images/ArrowRight.svg',
  [ArrowDirection.UpRight]: 'images/ArrowUpRight.svg',
  [ArrowDirection.DownRight]: 'images/ArrowDownRight.svg',
};

export default Vue.extend({
  props: {
    cell: Object as PropType<ICell>,
    puzzleColumns:[String, Number],
    puzzleRows:[String, Number],
  },
  methods: {
    directionToImageURL(direction): string {
      return arrowDirToURL[direction];
    },
  },
  computed: {
    correct(): boolean {
      return this.cell.state === CellState.Correct;
    },
    revealed(): boolean {
      return this.cell.state === CellState.Revealed;
    },
    error(): boolean {
      return this.cell.state === CellState.Error;
    }
  },
  render() {
    const { cell, puzzleColumns, puzzleRows, revealed, correct, error, directionToImageURL } = this;
    
    const bigGrid = puzzleRows > 16 || puzzleColumns > 16

    const getNumberClass = () => {
      if(!OS.desktop){
        if(!bigGrid){
          return style.number_mobile
        } else {
          return style.grid21_number_mobile
        }
      }

      return style.number
    };

    const getLettersClass = () => {
      if(!OS.desktop){
        if(!bigGrid){
          return style.letter_mobile
        } else {
          return  style.grid21_letter_mobile
        }
      }

      return style.letter_desktop
    };

    const getArrowImgs = () => {
      if (!cell.arrowImages) return null;
      return (
        <div>
          {cell.arrowImages.map(direction => (
            <img
              class={style.arrowImage}
              src={directionToImageURL(direction)}
              draggable="false" />
          ))}
        </div>
      );
    };

    return (
      <div>
        { getArrowImgs()}

        { cell.circle ? <div class={style.circle}></div> : null}

        { cell.number ? (
          <div class={[
            style.number,
            getNumberClass()
          ]}>
            {cell.number}
          </div>
        ) : null}

        <div class={{
          [style.letter]: true,
          [getLettersClass()]: true, 
          [style.letterRevealed]: revealed,
          [style.letterCorrect]: correct,
          [style.letter_error]: error,
        }}>
          {cell.letter}
        </div>

        { revealed ? <div class={style.revealMark}></div> : null}
      </div>
    );
  }
});
